import React from "react";
import EditShipment from "../../../Features/Forms/Shipment/Edit";

const Edit = () => {
  return (
    <div>
      <EditShipment />
    </div>
  );
};

export default Edit;
